import { ApiConsumes, ApiHeader, ApiOperation, ApiParam, ApiQuery, ApiTags } from '@nestjs/swagger';
import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { Controller, Post, Body, Req, Query, UseInterceptors, UploadedFiles, Get, Param, Res} from '@nestjs/common';
import { WelfareService } from './welfare.service';
import { AllWelfareResponseModel, SingleWelfareResponseModel, WelfareResponseModel } from './dto/welfare-response-model';
import { WelfareStatusWiseResponseModel} from './dto/welfare-status-response.model';
import { from } from 'rxjs';
import { WelfareIdRequest } from './dto/welfare.request';
import {  WelfareDeleteDTO, WelfareDTO, WelfareStatusDto,  } from './dto/welfare.dto';
import { extname } from 'path';
import { FilesInterceptor } from '@nestjs/platform-express';
import { diskStorage } from 'multer';
import { imageFileFilter } from '../shared/file-upload';

@ApiTags('welfare')
@Controller('welfare')
export class WelfareController {
  constructor(
    private WelfareService: WelfareService
  ){}

  @ApiHeader({
    name:'Authorization',
    description:'Authorization token'
  })  
  @Post('/createWelfare') 
  @ApiQuery({name:'apiVersion'})   
  @UseInterceptors(
    FilesInterceptor('attachments', 5, {
      fileFilter: imageFileFilter,
      storage: diskStorage({
        destination: './public/welfareImages',
        filename: function (req, file, callback) {
          const name = file.originalname.split('.')[0];
          const fileExtName = extname(file.originalname);
          const randomName = Array(4)
            .fill(null)
            .map(() => Math.round(Math.random() * 16).toString(16))
            .join('');
          callback(null, `${name}-${randomName}${fileExtName}`);
        }
      }),			
    }),
  )
  @ApiConsumes('multipart/form-data')
  async createWelfare(@Query() queryParam,@UploadedFiles() attachments,@Body() welfareDto:WelfareDTO,@Req() request:Request): Promise<WelfareResponseModel> {
    try {
        const welfareData = await this.WelfareService.createWelfare(queryParam, welfareDto);
        const response = [];
        attachments.forEach(file => {
              const fileReponse = {
                  welfareId:welfareData.Id,
                  attachmentsUrl: `welfare/welfareImages/${file.filename}`,
              };            
              response.push(fileReponse);
          })
          return await this.WelfareService.createWelfarefiles(queryParam, response,welfareData.Id);         
      } catch (error) {
          return errorHandler(WelfareResponseModel, error);
      }
  }

  @ApiHeader({
    name:'Authorization',
    description:'Authorization token'
  })
  @Post('/updatewelfare')
  @ApiQuery({name:'apiVersion'})
  @UseInterceptors(
    FilesInterceptor('attachments', 5, {
      fileFilter: imageFileFilter,
      storage: diskStorage({
        destination: './public/welfareImages',
        filename: function (req, file, callback) {
          const name = file.originalname.split('.')[0];
          const fileExtName = extname(file.originalname);
          const randomName = Array(4)
            .fill(null)
            .map(() => Math.round(Math.random() * 16).toString(16))
            .join('');
          callback(null, `${name}-${randomName}${fileExtName}`);
        }
      }),			
    }),
  )
  @ApiConsumes('multipart/form-data')
  async updateWelfare(@Query() queryParams, @UploadedFiles() attachments,@Body() welfareDto:WelfareDTO, @Req() request: Request): Promise<SingleWelfareResponseModel> {
      try {
          const response = [];
          attachments.forEach(file => {
            const fileReponse = {
                welfareId:welfareDto.Id,
                attachmentsUrl: `welfare/welfareImages/${file.filename}`,
            };            
            response.push(fileReponse);
        })          
        return await this.WelfareService.updateWelfare(queryParams, response,welfareDto, request);
      } catch (error) {
          return errorHandler(SingleWelfareResponseModel, error);
      }
  } 

  @ApiHeader({
    name:'Authorization',
    description:'Authorization token'
  })  
  @Get('/getAllActiveWelfare/:userId')
  @ApiOperation({summary:'get list with filter - type means: all = 0, Yet to start = 1 , In progress  = 2, Completed =3'})
  @ApiQuery({name:'apiVersion'})
  @ApiQuery({name:'skip'})
  @ApiQuery({name:'type'})
  @ApiQuery({name:'welfaretypeId',required: false})
  @ApiParam({name:'userId'})
  async getAllActiveWelfare(@Query() queryParams, @Param('userId') userId, @Req() request:Request): Promise<AllWelfareResponseModel> {
    try {
      return await this.WelfareService.getAllActiveWelfare(queryParams,userId,request);
    } catch (error) {
      return errorHandler(AllWelfareResponseModel, error);
    }
  }

  @ApiHeader({
    name:'Authorization',
    description:'Authorization token'
  })  
  @Get('/getWelfareByWelfareId/:Id')
  @ApiQuery({name:'apiVersion'})
  @ApiParam({name:'Id'})
  async getWelfareByWelfareId(@Query() queryParams, @Param('Id') Id, @Req() request:Request): Promise<SingleWelfareResponseModel> {
    try {
      return await this.WelfareService.getWelfareByWelfareId(queryParams,Id,request);
    } catch (error) {
      return errorHandler(SingleWelfareResponseModel, error);
    }
  }

  /* @ApiHeader({
    name:'Authorization',
    description:'Authorization token'
  })  
  @Post('/getActiveWelfareCount')
  @ApiQuery({name:'apiVersion'})
  async getActiveWelfareCount(@Query() queryParams, @Req() request:Request): Promise<WelfareStatusWiseResponseModel> {
    try {
      return await this.WelfareService.getActiveWelfareCount(queryParams, request);
    } catch (error) {
      return errorHandler(WelfareStatusWiseResponseModel, error);
    }
  } */

  @ApiHeader({
    name:'Authorization',
    description:'Authorization token'
  })  
  @Post('/updateWelfareStatus')
  @ApiQuery({name:'apiVersion'})
  async updateWelfareStatus(@Query() queryParams, @Body() welfareDeleteDto:WelfareDeleteDTO ,@Req() request:Request): Promise<WelfareResponseModel> {
    try {
      return await this.WelfareService.updateWelfareStatus(queryParams,welfareDeleteDto, request);
    } catch (error) {
      return errorHandler(WelfareResponseModel, error);
    }
  }

@ApiHeader({
    name:'Authorization',
    description:'Authorization token'
})  
  @Post('/changeWelfareStatus')
  @ApiQuery({name:'apiVersion'})
  async changeWelfareStatus(@Query() queryParams, @Body() welfareStatusDto:WelfareStatusDto ,@Req() request:Request): Promise<SingleWelfareResponseModel> {
    try {
      return await this.WelfareService.changeWelfareStatus(queryParams,welfareStatusDto, request);
    } catch (error) {
      return errorHandler(SingleWelfareResponseModel, error);
    }
  }


  @Get('welfareImages/:imgpath')
    @ApiParam({name:'imgpath'})
    seeUploadedFile(@Param('imgpath') attachments, @Res() res) {
		try {
			return res.sendFile(attachments, { root: './public/welfareImages' });
		} catch (error) {
			return error.message;
		}
    }

} 
